<script>
export default {
name: "CTAbanner"
}
</script>

<template>
  <section class="cta">
        <div class="cta-text-container">
            <div class="cta-title">{{__('Скачайте Cloud Mods')}}</div>
            <div class="cta-desc">{{__('и моментально прокачайте свой игровой опыт с качественными модификациями от самых талантливых авторов, которые установятся автоматически')}}</div>
        </div>
        <a href="/CloudModsSetup.exe" download class="cta-button">
            <svg class="icondnwld" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16.89C11.84 16.89 11.69 16.865 11.55 16.815C11.41 16.765 11.28 16.68 11.16 16.56L6.84002 12.24C6.60002 12 6.48502 11.72 6.49502 11.4C6.50502 11.08 6.62002 10.8 6.84002 10.56C7.08002 10.32 7.36502 10.195 7.69502 10.185C8.02502 10.175 8.31002 10.29 8.55002 10.53L10.8 12.78V4.2C10.8 3.86 10.915 3.575 11.145 3.345C11.375 3.115 11.66 3 12 3C12.34 3 12.625 3.115 12.855 3.345C13.085 3.575 13.2 3.86 13.2 4.2V12.78L15.45 10.53C15.69 10.29 15.975 10.175 16.305 10.185C16.635 10.195 16.92 10.32 17.16 10.56C17.38 10.8 17.495 11.08 17.505 11.4C17.515 11.72 17.4 12 17.16 12.24L12.84 16.56C12.72 16.68 12.59 16.765 12.45 16.815C12.31 16.865 12.16 16.89 12 16.89ZM4.80002 22.2C4.14002 22.2 3.57502 21.965 3.10502 21.495C2.63502 21.025 2.40002 20.46 2.40002 19.8V17.4C2.40002 17.06 2.51502 16.775 2.74502 16.545C2.97502 16.315 3.26002 16.2 3.60002 16.2C3.94002 16.2 4.22502 16.315 4.45502 16.545C4.68502 16.775 4.80002 17.06 4.80002 17.4V19.8H19.2V17.4C19.2 17.06 19.315 16.775 19.545 16.545C19.775 16.315 20.06 16.2 20.4 16.2C20.74 16.2 21.025 16.315 21.255 16.545C21.485 16.775 21.6 17.06 21.6 17.4V19.8C21.6 20.46 21.365 21.025 20.895 21.495C20.425 21.965 19.86 22.2 19.2 22.2H4.80002Z" fill="white"/>
            </svg>
            {{__('Скачать для Windows')}}
        </a>
  </section>
</template>

<style scoped>
.cta {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.cta-text-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.cta-title {
    font-style: normal;
    font-weight: 600;
    color: var(--text-primary);
}

.cta-desc {
    font-style: normal;
    font-weight: 500;
    color: var(--text-accent);
    text-align: center;
}

.cta-button {
    display: flex;
    align-items: center;
    justify-content: center;

    transition: 0.25s ease;
    background: var(--color-main);
}

.cta-button:hover {
    cursor: pointer;
    background: #6143CE;
}

@media (min-width: 320px) {
    .cta {
        display: none;
    }
}

@media (min-width: 464px) {
    .cta {
        display: flex;
        height: 215px;
        background-image: url("@/assets/images/cta464.png");
        border-radius: 25px;

        gap: 16px;
    }

    .cta-text-container {
        gap: 8px;
    }

    .cta-title {
        font-size: 20px;
    }

    .cta-desc {
        width: 586px;
        font-size: 16px;
    }

    .cta-button {
        padding: 12px 20px;
        border-radius: 12px;
        gap: 8px;
    }
}

@media (min-width: 744px) {
    .cta {
        height: 252px;
        background-image: url("@/assets/images/cta1248.png");
        border-radius: 25px;

        gap: 18px;
    }

    .cta-text-container {
        gap: 12px;
    }

    .cta-title {
        font-size: 26px;
    }

    .cta-desc {
        width: 586px;
        font-size: 20px;
    }

    .cta-button {
        padding: 12px 20px;
        border-radius: 12px;
        gap: 8px;
    }
}

@media (min-width: 984px) {
    .cta {
        height: 253px;
        background-image: url("@/assets/images/cta1248.png");
        border-radius: 25px;

        gap: 18px;
    }

    .cta-text-container {
        gap: 12px;
    }

    .cta-title {
        font-size: 28px;
    }

    .cta-desc {
        width: 586px;
        font-size: 22px;
    }

    .cta-button {
        padding: 12px 20px;
        border-radius: 12px;
        gap: 8px;
    }
}

@media (min-width: 1248px) {
    .cta {
        height: 280px;
        background-image: url("@/assets/images/cta1248.png");
        border-radius: 25px;

        gap: 20px;
    }

    .cta-text-container {
        gap: 12px;
    }

    .cta-title {
        font-size: 32px;
    }

    .cta-desc {
        width: 586px;
        font-size: 22px;
    }

    .cta-button {
        padding: 12px 20px;
        border-radius: 12px;
        gap: 8px;
    }
}
</style>